enum CivilizationsEnum {
    RANDOM = 'RANDOM',
    ABBASID = 'ABBASID',
    CHINESE = 'CHINESE',
    HRE = 'HRE',
    ENGLAND = 'ENGLAND',
    DELHI = 'DELHI',
    FRENCH = 'FRENCH',
    MONGOLS = 'MONGOLS',
    RUS = 'RUS',
    OTTOMANS = 'OTTOMANS',
    MALIANS = 'MALIANS',
    JEANNE_D_ARC = 'JEANNE_D_ARC',
    DRAGON_ORDER = 'DRAGON_ORDER',
    ZHU_XIS_LEGACY = 'ZHU_XIS_LEGACY',
    AYYUBIDS = 'AYYUBIDS',
    JAPANESE = 'JAPANESE',
    BYZANTINES = 'BYZANTINES',
    KNIGHTS_TEMPLAR = 'KNIGHTS_TEMPLAR',
    HOUSE_OF_LANCASTER = 'HOUSE_OF_LANCASTER',
    GOLDEN_HORDE = 'GOLDEN_HORDE',
    MACEDONIAN_DYNASTY = 'MACEDONIAN_DYNASTY',
    SENGOKU_DAIMYO = 'SENGOKU_DAIMYO',
    TUGHLAQ_DYNASTY = 'TUGHLAQ_DYNASTY',
}

export default CivilizationsEnum;
